import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import React from 'react';
import P, { InferProps } from 'prop-types';
import { SxStyle } from '../../types';

const styles: SxStyle = {
  tableRow: (theme) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.shades.p10,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }),
  tableCellLeft: (theme) => ({
    width: '250px',
    [theme.breakpoints.down('md')]: {
      width: '40%',
    },
  }),
};

export type DetailsRow = {
  label: string;
  value: string | number;
};

interface DetailsTableProps {
  rows: DetailsRow[];
}

function DetailsTable({ rows }: DetailsTableProps) {
  return (
    <TableContainer>
      <Table>
        <TableBody>
          {rows.map((row, i) => (
            <TableRow key={i} sx={styles.tableRow}>
              <TableCell sx={styles.tableCellLeft}>
                <Typography variant="subtitle2">{row.label}</Typography>
              </TableCell>
              <TableCell>{row.value}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default React.memo(DetailsTable);
